<template>
  <div class="mt-5">
    <div v-if="order.is_reviewed" class="success-message text-center">
      {{ in18['success-message'] }}
    </div>
    <form v-else @submit.prevent="submitReview">
      <div class="row mb-5" v-for="(item, index) in order.cart.items" :key="item.product.id">
        <div class="col-md-3">
          <a :href="item.product.link" :title="item.product.title">
            <picture>
              <source :data-srcset="item.product.image.webp" type="image/webp">
              <img
                  class="lazyload img m-auto"
                  :data-src="item.product.image.source"
                  :alt="item.product.title"
                  :title="item.product.title"
                  width="100"
                  height="100"
              >
            </picture>
          </a>
        </div>

        <div class="col-md-9">
          <a class="review-title" :href="item.product.link" :title="item.product.title">
            {{ item.product.title }}
          </a>
          <div class="product-text mt-3">
            <textarea
                class="review-comment"
                v-model="reviews[index].comment"
                :placeholder="in18['leave_comment']"
            ></textarea>
          </div>
          <div class="rating-area rating-wrap mb-4">
            <template v-for="star in [5, 4, 3, 2, 1]">
              <input
                  type="radio"
                  :id="`star-${star}_${item.product.id}`"
                  v-model="reviews[index].rate"
                  :value="star"
              >
              <label :for="`star-${star}_${item.product.id}`">&#9733;</label>
            </template>
          </div>
        </div>
        <hr>
      </div>

      <div class="row text-center">
        <div class="col-md-12">
          <button class="btn btn--green btn--md" type="submit" :disabled="inProgress">
            {{ in18['submit_reviews'] }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ValidationError from '../../features/ValidationError.vue';
import axios from 'axios';

export default {
  name:       'OrderReviewsForm',
  components: {
    ValidationError
  },
  props:      {
    order: {
      type:     Object,
      required: true
    },
    in18:  {
      type:     Object,
      required: true
    }
  },
  data() {
    return {
      reviews:     this.order.cart.items.map(item => ({
        product_id: item.product.id,
        rate:       1,
        comment:    ''
      })),
      inProgress:  false,
      isSubmitted: false,
      order:       this.order,
    };
  },
  methods: {
    submitReview() {
      this.inProgress = true;
      axios.post('/api/product-review/' + this.order.id + '/store', {'reviews': this.reviews})
          .then(response => {
            this.isSubmitted = true;
            this.order = response.data.order;
            //window.ga_submit_review_event(this.order, this.reviews);
            console.log('success. OK');
          })
          .catch(error => {
            console.error('Error submitting reviews', error);
          })
          .finally(() => {
            this.inProgress = false;
          });
    },

  }
};
</script>

<style scoped>
textarea {
  border: 1px solid #eeeeee;
}

.review-title {
  font-size: 16px;
  font-weight: 500;
}
</style>
